import { formatDate, timeSince } from '@/lib/date/date'

import { LAST_CHANGED_LABELS } from './labels'

type LastChangedProps = {
  lastChanged: Date
  withTimeCount?: boolean
}

export const LastChanged = ({ lastChanged, withTimeCount = true }: LastChangedProps) => {
  const { value, unit } = timeSince(lastChanged)
  return (
    <span className='text-nowrap pl-2 text-xs text-main-foreground-placeholder'>
      {LAST_CHANGED_LABELS.since} {formatDate(new Date(lastChanged))}{' '}
      {withTimeCount && `(${value} ${unit})`}
    </span>
  )
}
